<ng-container *ngIf="(infoMessage | hisUi) && (infoMessage | hisUi).charAt(0) !== '?'">
    <div class="layoutBlock">
        <div class="columnFullWidth">
            <p-panel [header]="infoHeader | hisUi">
                <div [innerHTML]="infoMessage | hisUi"></div>
            </p-panel>
            <br>
        </div>
    </div>
</ng-container>